module.exports = __webpack_public_path__ + "static/media/lumbering25.a9b00d92.jpg";